// src/pins.ts
// Your pinned board posts. Pins are private (users/{uid}/private/pins),
// so nobody else can see what you've pinned.
import { useEffect, useState } from "react";
import { arrayRemove, arrayUnion, doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "./firebase";

const pinsRef = (uid: string) => doc(db, "users", uid, "private", "pins");

export const MAX_PINS = 100;

export function usePins(uid?: string): string[] {
  const [pins, setPins] = useState<string[]>([]);
  useEffect(() => {
    if (!uid) {
      setPins([]);
      return;
    }
    return onSnapshot(
      pinsRef(uid),
      (snap) => setPins(snap.exists() ? snap.data().adIds || [] : []),
      (err) => console.warn("Pins:", err)
    );
  }, [uid]);
  return pins;
}

export async function setPinned(uid: string, adId: string, pinned: boolean) {
  await setDoc(
    pinsRef(uid),
    { adIds: pinned ? arrayUnion(adId) : arrayRemove(adId) },
    { merge: true }
  );
}
